import React, { useState } from 'react';
import TruckDriverIcon from '@mui/icons-material/AirlineSeatReclineNormal';

import { MenuAnchor } from '@paragon/client-tools';
import { TruckDriver } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { useAppSelector } from '../../hooks';
import { TruckDriverMenu } from '../menus/TruckDriverMenu';
import { BaseCard } from './BaseCard';

export function TruckDriverCard(props: { truckDriver: TruckDriver }) {
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  return (
    <BaseCard
      title={props.truckDriver.name}
      subheader={props.truckDriver.archived ? 'Archived' : null}
      avatar={<TruckDriverIcon />}
      menu={
        isSupervisor ? (
          <TruckDriverMenu truckDriver={props.truckDriver} anchor={menuAnchor} onClose={() => setMenuAnchor(null)} />
        ) : undefined
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
